import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import formatPhoneNumber from 'helpers/formatPhoneNumber';
import './Contact.css';

const Contact = props => (
  <div className="contact">
    {props.Photo && (
      <div className="contact__photo">
        <img src={`data:image/jpeg;base64,${props.Photo}`} alt={props.Name} />
      </div>
    )}
    <div className="contact__information">
      <div className="contact__information__name">{props.Name}</div>
      {props.Title && (
        <div className="contact__information__title">{props.Title}</div>
      )}
      {props.Company && (
        <div className="contact__information__company">{props.Company}</div>
      )}
      <div className="contact__information__phone__group">
        {props.OfficeTelephone && (
          <div className="contact__information__phone">
            <span>O: </span>
            {formatPhoneNumber(props.OfficeTelephone)}
            {props.Ext !== '' && props.Ext !== null &&
              <Fragment>
                <span>Ext:</span>{' '}
                {props.Ext}
              </Fragment>
            }
          </div>
        )}
        {props.CellPhoneNumber && (
          <div className="contact__information__phone">
            <span>C: </span>
            {formatPhoneNumber(props.CellPhoneNumber)}
          </div>
        )}
      </div>
      <div className="contact__information__email">
        <a href={`mailto: ${props.Email}`}>{props.Email}</a>
      </div>
    </div>
  </div>
);

Contact.propTypes = {
  Name: PropTypes.string,
  Company: PropTypes.string,
  Title: PropTypes.string,
  OfficeTelephone: PropTypes.string,
  CellPhoneNumber: PropTypes.string,
  Email: PropTypes.string,
  Photo: PropTypes.string,
  Ext: PropTypes.string,
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.jsx